module.exports = __webpack_public_path__ + "img/1F1EE-1F1F6.7eea0da4.svg";